export const contentContainer = {
  width: "100%",
  padding: "40px",
  display: "flex",
  flexDirection: "column",
  zIndex: 90,
  position: "relative",
};

export const modalTitle = {
  textTransform: "uppercase",
  paddingBottom: "20px",
  borderBottom: "solid 4px",
  borderColor: "grey9",
  lineHeight: "30px",
};

export const descriptionText = {
  marginTop: "20px",
  letterSpacing: "0.05em",
};

export const buttonsContainer = {
  marginTop: "20px",
  paddingTop: "20px",
  display: "flex",
  justifyContent: "space-between",
  borderTop: "solid 1px",
  borderColor: "grey9",
};
